
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 46 46"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23 .5A22.5 22.5 0 1045.5 23 22.5 22.5 0 0023 .5z","fill":"#fff","stroke":"#515358","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M31.19 14.1a.46.46 0 00-.42-.27H17.52v10.09h13.07a.46.46 0 00.46-.46.43.43 0 00-.12-.31L27.11 19l4-4.37a.48.48 0 00.08-.53zM16.61 14.37v-.54a.92.92 0 00-.92-.92.92.92 0 00-.92.92v18.34a.92.92 0 00.92.92.92.92 0 00.92-.92z","fill":"#515358"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/annotationPoint.svg